import React from 'react';
import './CookieConsentBanner.css';

export default function CookieConsentBanner({ onAccept, onDecline, onViewPolicy }) {
    return (
        <div className="ccb-bar" role="dialog" aria-live="polite" aria-label="Cookie notice" data-testid="cookie-consent-banner">
            <p className="ccb-text">
                We use cookies to analyze site traffic and improve your experience. By clicking "Accept", you consent to our use of cookies as described in our{' '}
                <button type="button" className="ccb-link" onClick={onViewPolicy} data-testid="cookie-consent-policy-link">
                    Cookie Policy
                </button>.
            </p>
            <div className="ccb-actions">
                <button type="button" className="ccb-btn ccb-btn-decline" onClick={onDecline} data-testid="cookie-consent-decline">
                    Decline
                </button>
                <button type="button" className="ccb-btn ccb-btn-accept" onClick={onAccept} data-testid="cookie-consent-accept">
                    Accept
                </button>
            </div>
        </div>
    );
}
